module.exports = __webpack_public_path__ + "static/media/Sitting_Right_Hand.9eddaf82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/position_icons/Sitting_Right_Hand.svg
// module id = 755
// module chunks = 0